export const environment = {
  production: false,
  azure: {
    clientId: '4c8ae0e6-e61b-4e3b-9bf4-7468ae1a2151',
    tenantId: '38ae3bcd-9579-4fd4-adda-b42e1495d55a',
    redirectUri: 'https://eng-vpc-dev.siemens.com',
    graphScopes: ['openid', 'profile'],
    base_url: 'https://eng-vpc-dev.siemens.com/api',
  },

  apiServer: '',
};
